<template>
    <el-button class="icon-btn"><font-awesome-icon icon="fa-solid fa-qrcode" /></el-button>
</template>

<script setup>
    import { library } from '@fortawesome/fontawesome-svg-core'
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
    import {faQrcode} from '@fortawesome/free-solid-svg-icons'

    library.add(faQrcode)
</script>

<style scoped>
    .icon-btn {
        padding: 8px;
    }
</style>